import React from 'react';
import { Box, Flex, Heading } from 'rebass';
import Frame from 'components/Frame';
import RecruiterDashBoard from 'modules/DashBoard/components/RecruiterDashBoard';
import EmployerDashBoard from 'modules/DashBoard/components/EmployerDashBoard';
import { UserRoleInterface } from 'types/global';

const DashBoard: React.FC<UserRoleInterface> = ({ userRole }): JSX.Element => {
  return (
    <>
      <Box>
        <Frame>
          <Flex width="100%" flexDirection="column" py={7}>
            <Heading as="h2" fontSize="36px" fontWeight={5} mb={6}>
              Dashboard
            </Heading>
            {userRole === 'RECRUITER' ? <RecruiterDashBoard /> : <EmployerDashBoard />}
          </Flex>
        </Frame>
      </Box>
    </>
  );
};

export default DashBoard;
